import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import { bindAll } from '@bibliocommons/utils-react';
import { ReadInBrowser as ReadInBrowserIcon, ExternalArrow } from '@bibliocommons/deprecated-base-icons';
import { checkoutsEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { Link } from '@bibliocommons/base-links';

import './CheckedOutReadingLinks.scss';

const { composeReadInBrowserEvent } = checkoutsEventComposer;

export default class ThirdPartyReaderLink extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleReaderLinkClick() {
    const { provider } = this.props;
    sendAnalyticsEvents(composeReadInBrowserEvent({ provider }));
  }

  render() {
    const { className, withIcons } = this.props;

    return (
      <Link
        target="_blank"
        href={this.props.thirdPartyReaderUrl}
        handleClick={this.handleReaderLinkClick}
        className={cn('cp-third-party-reader-link', className)}
        dataKey="link_thirdparty_reader"
        screenReaderText={<FormattedMessage id="open_in_third_party_reader" />}
      >
        {withIcons && <ReadInBrowserIcon />}
        <span aria-hidden>
          <FormattedMessage id="open_in_third_party_reader" />
        </span>
        <ExternalArrow />
      </Link>
    );
  }
}

ThirdPartyReaderLink.propTypes = {
  thirdPartyReaderUrl: PropTypes.string,
  provider: PropTypes.string,
  withIcons: PropTypes.bool,
  className: PropTypes.string
};
